import { array, object, string } from "zod/v4";

export const getProductQuestions = {
  name: "getProductQuestions" as const,
  input: object({ productId: string() }),
  output: object({ questions: array(string()) }),
};
